// eslint-disable-next-line max-classes-per-file
import {ProcessFlowBaseNode} from './process-flow-base-node';
import {ProcessFlowNodeOutlet} from './process-flow-node-outlets';

export class StartNode extends ProcessFlowBaseNode {
  constructor(v: Partial<StartNode>) {
    super(v);
    this.type = 'ProcessFlow::StartNode';

    this.supportedOutlets = [
      ProcessFlowNodeOutlet.COMPLETED_OUTLET
    ];
  }
}
